import QuestionPage from '../../templates/question';
import Checkbox from '../../molecules/checkboxQuestion';
import { Q } from '../../../store/student/types';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { useDispatch } from 'react-redux';
import { updateLegalAdviseDisclaimer } from '../../../store/student/core/actions';

export interface IProps {
  complete: boolean;
  legalAdviseDisclaimer: boolean;
  config: any;
}

type Props = IProps;

const LegalAdviseDisclaimer = (props: Props) => {
  const { navigateForward } = useCustomNavigate();
  const onNext = () => {
    navigateForward();
  };

  const dispatch = useDispatch();
  const onChange = (info: boolean) => dispatch(updateLegalAdviseDisclaimer(info));

  const handleChange = (_key: string, isTicked: boolean) => {
    onChange(isTicked);
  };

  const pageTitle = props.config?.Checklist?.Landing?.title || 'Welcome';

  return (
    <QuestionPage complete={props.complete} section={pageTitle} onNext={onNext} hideProgress={true}>
      <Checkbox
        key={Q.LEGAL_ADVICE_DISCLAIMER}
        id={Q.LEGAL_ADVICE_DISCLAIMER}
        blurb={props.config?.Checklist?.Landing?.blurb}
        isTicked={props.legalAdviseDisclaimer}
        checkboxLabel={'I understand'}
        onChange={handleChange}
      />
    </QuestionPage>
  );
};

export default LegalAdviseDisclaimer;
